/**
 * ソート可能な <th> セル
 * useTableSort と組み合わせて利用
 */
import { ChevronUp, ChevronDown, ChevronsUpDown } from 'lucide-react';
import type { SortDir } from '@/hooks/useTableSort';

export type SortableThProps = {
  sortKey: string;
  currentKey: string | null;
  dir: SortDir;
  onClick: (key: string) => void;
  align?: 'left' | 'right' | 'center';
  className?: string;
  /** ボタンのホバー時に表示する tooltip (ソート挙動の補足など)。省略時は自動でソート状態を示す */
  title?: string;
  children: React.ReactNode;
};

export function SortableTh({
  sortKey, currentKey, dir, onClick, align = 'left', className = '', title, children,
}: SortableThProps) {
  const active = currentKey === sortKey;
  const alignCls = align === 'right' ? 'justify-end text-right' : align === 'center' ? 'justify-center text-center' : 'justify-start text-left';
  const defaultTitle = active
    ? `${dir === 'asc' ? '昇順' : '降順'}で並び替え中。クリックで${dir === 'asc' ? '降順' : '昇順'}に切替`
    : 'クリックで並び替え';
  return (
    <th
      scope="col"
      aria-sort={active ? (dir === 'asc' ? 'ascending' : 'descending') : 'none'}
      className={`px-3 py-2 ${className}`}
    >
      <button
        type="button"
        onClick={() => onClick(sortKey)}
        title={title ?? defaultTitle}
        className={`w-full flex items-center gap-1 ${alignCls} hover:text-brand-red transition ${active ? 'text-brand-red font-medium' : ''}`}
      >
        {children}
        <span className="inline-flex shrink-0">
          {active
            ? (dir === 'asc' ? <ChevronUp size={12} /> : <ChevronDown size={12} />)
            : <ChevronsUpDown size={12} className="opacity-60 hover:opacity-100" />}
        </span>
      </button>
    </th>
  );
}
